// Guías de Aprender · Partidas, historial y repeticiones (2026-10-18).

export const PARTIDAS_GUIDES = [
  {
    slug: "partidas-online",
    theme: "partidas",
    nav: "Jugar online",
    title: "Jugar XIMA online: partidas en vivo contra personas",
    description:
      "Cómo jugar XIMA online gratis: encontrar rival, unirte a una partida abierta, crear la tuya o jugar con un amigo. Todo desde el navegador o el móvil.",
    h1: "Jugar online",
    intro:
      "En juegoxima.com puedes jugar XIMA en vivo contra personas de cualquier lugar, desde el ordenador o el móvil y sin instalar nada. Estas son las formas de encontrar partida.",
    sections: [
      {
        h: "Las formas de jugar",
        list: [
          "Unirte a una partida abierta: en el lobby y en Todos los torneos ves las partidas que esperan jugadores, con su modo, jugadores y tiempo. Pulsa Unirse.",
          "Crear tu propia partida: eliges modo, número de jugadores y tiempo por turno, y esperas a que entren rivales.",
          "Jugar con un amigo: desde Amigos lo invitas o lo retas directamente.",
          "Entrar en un torneo o en el Campeonato: competiciones con más jugadores y, a veces, premio.",
        ],
      },
      {
        h: "Antes de empezar",
        list: [
          "Regístrate para que tus partidas cuenten en el historial, las estadísticas y el CIMAX. Con un enlace de invitado puedes jugar sin cuenta y registrarte después sin perder el resultado.",
          "Elige el modo con calma: Ciencia sin dados, Azar con dados, Cienzar o Ciencia V/S Azar.",
          "Fíjate en el tiempo por turno: 1, 2, 5 o 10 minutos. Con poco tiempo la partida es más rápida, pero más exigente.",
        ],
      },
      {
        h: "Durante la partida",
        p: [
          "En el ordenador verás a un lado tu reloj, el modo y los jugadores, y al otro el reloj del rival, el chat, el control de voz y el botón para rendirte. Puedes activar Seguir cámara, dibujar flechas sobre el tablero para explicar una jugada y cambiar la velocidad de las animaciones.",
          "Con dos jugadores aparece además una barra de evaluación junto al tablero que indica quién va mejor según el bot.",
        ],
      },
      {
        h: "Al terminar",
        p: [
          "La partida queda guardada en tu Historial. Desde ahí puedes verla de nuevo, analizarla con el bot o pedir la revancha a tu rival.",
        ],
      },
    ],
    faqs: [
      ["¿Jugar online es gratis?", "Sí. Puedes jugar todas las partidas que quieras sin pagar."],
      ["¿Puedo jugar desde el móvil?", "Sí, desde el navegador del móvil. En Android también puedes descargar la app."],
      ["¿Qué pasa si salgo de una partida?", "El juego te avisa antes de salir de una partida que todavía no ha terminado. Si la abandonas, tu rival gana."],
    ],
    related: ["tutoriales/crear-partida", "tutoriales/unirse-partida-privada", "lobby", "amigos", "torneos"],
    cta: { label: "Crear una partida", slug: "tutoriales/crear-partida" },
    legacy: ["partidas/independientes", "tutoriales/buscar-partidas", "partidas/publicas-y-privadas"],
  },
  {
    slug: "tutoriales/crear-partida",
    theme: "partidas",
    nav: "Crear una partida",
    title: "Crear una partida de XIMA paso a paso",
    description:
      "Cómo crear una partida de XIMA: elegir modo, jugar 1 contra 1, 1 contra 2 o 1 contra 3, tiempo por turno de 1 a 10 minutos y cómo invitar a tus rivales.",
    h1: "Crear una partida",
    intro:
      "Crear una partida te deja elegir exactamente cómo quieres jugar. En la pantalla Crear juego decides tres cosas: el modo, los jugadores y el tiempo.",
    sections: [
      {
        h: "1. El modo",
        p: [
          "Elige entre Ciencia (sin dados), Azar (dos dados), Cienzar (eliges en cada turno) o Ciencia V/S Azar (un bando con dados y otro sin ellos). Si no sabes cuál, empieza con Ciencia.",
        ],
      },
      {
        h: "2. Los jugadores",
        p: [
          "Puedes jugar 1 contra 1, 1 contra 2 o 1 contra 3. La partida empieza cuando entran todos los jugadores. Con más de dos, el tablero se llena antes y hay que vigilar a varios rivales a la vez.",
        ],
      },
      {
        h: "3. El tiempo por turno",
        p: [
          "Cada jugador tiene 1, 2, 5 o 10 minutos para hacer su jugada. Para aprender, elige 5 o 10 minutos; para partidas rápidas, 1 o 2.",
        ],
      },
      {
        h: "Invitar a tus rivales",
        p: [
          "Cuando la partida está creada, aparece en la lista para que otros se unan. Si quieres jugar con alguien concreto, compártele el enlace de la partida o invítalo desde Amigos. Con el enlace puede entrar incluso como invitado, sin registrarse.",
          "Las partidas de los retos entre amigos y algunos torneos llevan contraseña para que solo entren los invitados.",
        ],
      },
      {
        h: "Si no puedes crear la partida",
        list: [
          "Comprueba que has iniciado sesión.",
          "Revisa tu conexión y recarga la página una vez.",
          "Si estabas en otra partida, termínala o sal de ella primero.",
          "Si sigue fallando, escríbenos desde Soporte.",
        ],
      },
    ],
    steps: {
      title: "Crear una partida en 5 pasos",
      items: [
        "Abre Crear juego desde el lobby o el menú.",
        "Elige el modo de juego.",
        "Elige el número de jugadores.",
        "Elige el tiempo por turno.",
        "Crea la partida y espera a tus rivales o compárteles el enlace.",
      ],
    },
    faqs: [
      ["¿Puedo jugar contra el bot desde Crear juego?", "Para jugar contra el bot usa Jugar con bot, donde además eliges la dificultad."],
      ["¿Qué tiempo por turno elijo?", "Si estás aprendiendo, 5 o 10 minutos. Si ya conoces bien el juego, 1 o 2 para partidas rápidas."],
      ["¿Puedo cambiar el modo cuando ya creé la partida?", "No. Revisa bien la configuración antes de crearla."],
    ],
    related: ["partidas-online", "tutoriales/unirse-partida-privada", "modos-de-juego", "amigos"],
    cta: { label: "Unirse a una partida", slug: "tutoriales/unirse-partida-privada" },
    legacy: [
      "tutoriales/crear-partida-publica",
      "tutoriales/crear-partida-privada",
      "tutoriales/contrasena-de-partida",
      "tutoriales/tiempo-por-turno",
      "tutoriales/numero-de-jugadores",
      "solucion/no-puedo-crear-partida",
    ],
  },
  {
    slug: "tutoriales/unirse-partida-privada",
    theme: "partidas",
    nav: "Unirse a una partida",
    title: "Cómo unirse a una partida de XIMA (también privada)",
    description:
      "Cómo entrar en una partida de XIMA: desde la lista, con el enlace que te pasa un amigo, con contraseña o aceptando una invitación. Y qué hacer si no puedes entrar.",
    h1: "Unirse a una partida",
    intro:
      "Hay varias maneras de entrar en una partida que ha creado otra persona. Elige la que te corresponda.",
    sections: [
      {
        h: "Desde la lista",
        p: [
          "En el lobby y en Todos los torneos aparecen las partidas abiertas con su modo, número de jugadores y tiempo por turno. Usa los filtros si buscas algo concreto y pulsa Unirse.",
        ],
      },
      {
        h: "Con un enlace",
        p: [
          "Si un amigo te comparte el enlace de una partida, ábrelo y entrarás directamente en la sala. No hace falta tener cuenta: puedes jugar como invitado y registrarte al terminar sin perder el resultado.",
        ],
      },
      {
        h: "Con contraseña",
        p: [
          "Algunas partidas y torneos están protegidos con una contraseña numérica. Te la tiene que dar quien la creó; escríbela cuando el juego te la pida. Compártela solo con las personas que quieras invitar.",
        ],
      },
      {
        h: "Aceptando una invitación o un reto",
        p: [
          "Si un amigo te invita o te reta, te llega un aviso. Revisa el modo, el tiempo y, si es un reto con apuesta, las monedas en juego, y acéptalo para entrar.",
        ],
      },
      {
        h: "Si no puedes entrar",
        list: [
          "La partida ya puede estar llena o haber empezado.",
          "Revisa que la contraseña sea la correcta.",
          "Si estás en otra partida, sal primero de ella.",
          "Recarga la página una vez y vuelve a intentarlo.",
        ],
      },
    ],
    faqs: [
      ["¿Necesito cuenta para unirme?", "Con un enlace puedes entrar como invitado. Para que la partida cuente en tus estadísticas, regístrate."],
      ["¿Dónde consigo la contraseña de una partida privada?", "Te la tiene que dar quien la creó o el organizador del torneo."],
    ],
    related: ["tutoriales/crear-partida", "amigos", "partidas-online", "torneos"],
    cta: { label: "Jugar con amigos", slug: "amigos" },
    legacy: [
      "tutoriales/unirse-partida-amigo",
      "tutoriales/aceptar-invitacion-partida",
      "solucion/no-puedo-unirme-partida",
    ],
  },
  {
    slug: "lobby",
    theme: "partidas",
    nav: "El lobby y el menú",
    title: "El lobby de XIMA: menú, diseños y accesos",
    description:
      "Todo lo que hay en el lobby de XIMA: los diseños Clásico, Modo 3D y En vivo, el menú lateral, las partidas en vivo, las noticias y cómo moverte en el móvil.",
    h1: "El lobby y el menú",
    intro:
      "El lobby es la pantalla principal del juego. Desde ahí llegas a todo: jugar, ver partidas, aprender, la tienda o tus estadísticas.",
    sections: [
      {
        h: "Los diseños del lobby",
        list: [
          "Clásico: un diseño plano y claro. Es el que se usa por defecto.",
          "Modo 3D: el tablero en tres dimensiones girando, con botones en sus paredes.",
          "En vivo: en el centro se ve un partido que se está jugando en ese momento, con su tablero, y debajo otros partidos en miniatura.",
        ],
        after: ["Puedes cambiar de diseño cuando quieras desde el selector del lobby."],
      },
      {
        h: "El menú",
        p: ["En el menú lateral (abajo, en el móvil) están las secciones del juego:"],
        list: [
          "Jugar: Crear juego, Jugar con bot, Todos los torneos, Campeonato y Puzzles.",
          "Ver partidos: partidas en vivo y repeticiones.",
          "Historial y Estadísticas: tus partidas y tu progreso.",
          "Amigos, Noticias y Comunidad.",
          "Aprender, Tienda, Premium, Ajustes y Soporte.",
        ],
        after: [
          "Los puntos de color junto a una sección avisan de que hay algo nuevo: una respuesta de Soporte, una noticia, una solicitud de amistad…",
        ],
      },
      {
        h: "Lo que ves en el lobby",
        list: [
          "La lista de salas en vivo, que se actualiza sola.",
          "Un botón para buscar partida rápida.",
          "Las últimas noticias y el próximo campeonato.",
          "Tu perfil, tus monedas y tu CIMAX.",
        ],
      },
    ],
    faqs: [
      ["¿Cómo cambio el diseño del lobby?", "Con el selector de diseño del propio lobby: Clásico, Modo 3D o En vivo."],
      ["¿Dónde está el menú en el móvil?", "En la barra inferior de la pantalla."],
    ],
    related: ["partidas-online", "ver-partidos", "noticias", "compatibilidad-movil"],
    cta: { label: "Jugar online", slug: "partidas-online" },
    legacy: [
      "interfaz/menu-principal",
      "interfaz/boton-aprender",
      "interfaz/volver-al-lobby",
      "interfaz/notificaciones-menu",
      "movil/menu-inferior",
      "movil/menu-lobby",
    ],
  },
  {
    slug: "ver-partidos",
    theme: "partidas",
    nav: "Ver partidos",
    title: "Ver partidos de XIMA en vivo y repeticiones",
    description:
      "Mira partidas de XIMA en directo con su tablero, el turno y el reloj, o elige una repetición destacada. Una forma fácil de aprender viendo jugar a otros.",
    h1: "Ver partidos",
    intro:
      "Ver jugar a otros es una de las mejores formas de aprender. En Ver partidos puedes seguir partidas en vivo o abrir repeticiones de partidas ya terminadas.",
    sections: [
      {
        h: "Partidas en vivo",
        p: [
          "Cada partida en vivo muestra su tablero en 2D, de quién es el turno y cuánto tiempo le queda. Arriba aparece el partido destacado, el que tiene más espectadores en ese momento. Pulsa en una partida para verla con el tablero 3D.",
          "Si en ese momento nadie está jugando, la página te lo dice y te propone una buena repetición.",
        ],
      },
      {
        h: "Repeticiones",
        p: [
          "Con el filtro Repeticiones ves partidas ya terminadas. Las repeticiones son públicas: puedes abrir la de cualquier jugador para estudiar cómo juega. También puedes llegar al historial de un jugador pulsando su nombre en el ranking, en el lobby o en un torneo.",
        ],
      },
      {
        h: "Filtros",
        list: [
          "Ver: Todo, En vivo o Repeticiones.",
          "Modo: Ciencia, Azar, Cienzar o Ciencia V/S Azar.",
        ],
      },
      {
        h: "Cómo aprender viendo",
        list: [
          "Fíjate en cómo construye cada jugador sus escalones hacia el segundo piso.",
          "Observa cuándo mete cada uno su bloque especial.",
          "En la tercera planta, mira cómo usan la oposición de los especiales.",
        ],
      },
    ],
    faqs: [
      ["¿Puedo ver una partida sin jugar?", "Sí. Desde Ver partidos entras como espectador."],
      ["¿Puedo ver las partidas de otro jugador?", "Sí. Pulsa su nombre en el ranking, el lobby o un torneo y se abre su historial con sus repeticiones."],
    ],
    related: ["historial-y-replay", "replay/controles", "analizar-partida", "campeonato"],
    cta: { label: "Repetir una partida", slug: "replay/controles" },
    legacy: ["ver-partidos/en-vivo", "ver-partidos/tarjetas", "ver-partidos/refrescar", "replays-destacados"],
  },
  {
    slug: "historial-y-replay",
    theme: "historial",
    nav: "Historial de partidas",
    title: "Historial de partidas de XIMA: revisa cómo juegas",
    description:
      "El historial de XIMA guarda todas tus partidas con resultado, modo, rivales y fecha, una gráfica de tu progreso y acceso a la repetición y al análisis de cada una.",
    h1: "Historial de partidas",
    intro:
      "Cada partida que juegas queda guardada en tu Historial. Es el punto de partida para mejorar: ahí ves tus resultados, tu progreso y la repetición de cada partida.",
    sections: [
      {
        h: "Qué muestra",
        list: [
          "Cada partida con su resultado, el modo, los rivales y la fecha.",
          "Una gráfica con la evolución de tus resultados.",
          "Un botón para ver la repetición y otro para analizarla con el bot.",
          "Una marca ✓ en las partidas que ya analizaste.",
        ],
      },
      {
        h: "El historial de otros jugadores",
        p: [
          "Pulsa el nombre de cualquier jugador en el ranking, en Mejores jugadores, en el lobby, en un torneo o en Ver partidos y verás su historial y sus repeticiones. Es una buena forma de preparar una partida contra alguien o de aprender de los mejores.",
        ],
      },
      {
        h: "Si no ves una partida",
        list: [
          "Las partidas aparecen al terminar, no mientras se juegan.",
          "Si jugaste como invitado, regístrate para conservar tus partidas.",
          "Recarga la página si acabas de terminar una partida y aún no aparece.",
        ],
      },
    ],
    faqs: [
      ["¿Cuántas partidas guarda el historial?", "Todas las que juegas con tu cuenta."],
      ["¿Las repeticiones son públicas?", "Sí. Cualquier jugador puede ver la repetición de una partida desde el historial del jugador."],
    ],
    related: ["replay/controles", "analizar-partida", "descargar-video", "estadisticas"],
    cta: { label: "Ver una repetición", slug: "replay/controles" },
    legacy: ["historial", "tutoriales/actualizar-historial", "solucion/historial-vacio"],
  },
  {
    slug: "replay/controles",
    theme: "historial",
    nav: "Repetir una partida",
    title: "Repeticiones de XIMA: controles para estudiar partidas",
    description:
      "Cómo usar la repetición de una partida de XIMA: avanzar jugada a jugada, velocidad de 0,5x a 8x, lista de jugadas, cámara, flechas y versión para móvil.",
    h1: "Repetir una partida",
    intro:
      "La repetición reproduce una partida terminada jugada a jugada, en el tablero 3D. Sirve para entender qué pasó y en qué momento se decidió la partida.",
    sections: [
      {
        h: "Cómo abrirla",
        p: [
          "Desde tu Historial, desde el historial de otro jugador o desde Ver partidos, pulsa el botón de repetición de la partida que quieras ver.",
        ],
      },
      {
        h: "Los controles",
        list: [
          "Reproducir y pausar.",
          "Jugada anterior y siguiente, para avanzar paso a paso.",
          "Reiniciar, para volver al principio.",
          "Saltar al final, para ver la posición que decidió la partida.",
          "Velocidad: desde 0,5x (muy lento) hasta 8x (muy rápido).",
          "Seguir cámara: la vista sigue a cada bloque que se mueve. Si la apagas, mueves la cámara a tu gusto.",
          "Flechas: puedes dibujar flechas sobre el tablero para marcar una idea.",
        ],
      },
      {
        h: "La lista de jugadas",
        p: [
          "En el ordenador, la repetición muestra en tres columnas los jugadores con el tiempo que usó cada uno, el tablero y la lista de jugadas por turnos. Pulsa una jugada para ir directamente a ella. Si la partida fue con dados, también se ven los números que salieron.",
        ],
      },
      {
        h: "En el móvil",
        p: [
          "En el móvil la repetición ocupa toda la pantalla y los controles se agrupan abajo. En horizontal se ve mejor el tablero.",
        ],
      },
      {
        h: "Cómo estudiar una repetición",
        list: [
          "Mírala una vez entera a velocidad rápida para ver la idea general.",
          "Vuelve al momento en que el rival llegó al segundo o al tercer piso antes que tú.",
          "Pausa antes de cada captura y pregúntate si se podía evitar.",
          "Usa Analizar partida para que el bot te marque los errores.",
        ],
      },
      {
        h: "Si la repetición no se abre",
        list: [
          "Algunas partidas muy antiguas o interrumpidas no tienen repetición guardada.",
          "Recarga la página e inténtalo de nuevo.",
          "Si sigue sin abrir, escríbenos desde Soporte indicando la partida.",
        ],
      },
    ],
    faqs: [
      ["¿Puedo cambiar la velocidad de la repetición?", "Sí, desde 0,5x hasta 8x. Cambiar la velocidad no cambia nada de la partida."],
      ["¿Todas las partidas tienen repetición?", "Casi todas. Algunas partidas antiguas o que se cortaron no tienen los datos guardados."],
    ],
    related: ["analizar-partida", "historial-y-replay", "descargar-video", "sistema-de-anotacion"],
    cta: { label: "Analizar una partida", slug: "analizar-partida" },
    legacy: [
      "tutoriales/ver-replay",
      "replay/velocidad",
      "replay/timeline",
      "replay/pausar-reproducir",
      "replay/reiniciar",
      "replay/saltar-final",
      "replay/camara-libre",
      "replay/seguimiento-camara",
      "replay/movil",
      "replay/eventos",
      "solucion/no-hay-replay",
      "solucion/replay-no-reproduce",
    ],
  },
  {
    slug: "analizar-partida",
    theme: "historial",
    nav: "Analizar una partida",
    title: "Analizar tus partidas de XIMA con el bot",
    description:
      "Analiza tus partidas de XIMA con el bot: clasifica cada jugada (brillante, excelente, error…), marca la mejor jugada con una flecha verde y te enseña a mejorar.",
    h1: "Analizar una partida",
    intro:
      "Analizar partida pone al bot de XIMA a revisar tu partida jugada a jugada. Te dice qué jugadas fueron buenas, cuáles fueron errores y qué habría hecho él en cada momento.",
    sections: [
      {
        h: "Cómo funciona",
        p: [
          "Desde el Historial, pulsa el botón de analizar de una partida. El bot recorre todas las jugadas y, en la repetición, cada jugada aparece con un distintivo sobre el bloque que se movió. Cuando tu jugada no fue la mejor, una flecha verde marca la que el bot habría elegido.",
          "El análisis queda guardado: la próxima vez que abras esa partida no tendrás que esperar, y en el historial verás una marca ✓.",
        ],
      },
      {
        h: "Qué significa cada distintivo",
        table: {
          head: ["Distintivo", "Qué quiere decir"],
          rows: [
            ["Libro", "Una de las dos primeras jugadas de cada jugador."],
            ["Brillante", "La mejor jugada, y claramente mejor que cualquier otra."],
            ["Excelente", "Prácticamente tan buena como la mejor."],
            ["Buena", "Una jugada sólida."],
            ["Interesante", "Se perdió un poco, pero tiene su idea."],
            ["Imprecisión", "Había algo mejor."],
            ["Error", "Una jugada que empeoró bastante tu posición."],
            ["Error grave", "Una jugada que pudo costar la partida."],
          ],
        },
        after: [
          "Si le ganaste al bot, tus jugadas se valoran un nivel por encima: ¡ganarle no es fácil!",
        ],
      },
      {
        h: "Cuántos análisis puedes hacer",
        p: [
          "Sin Premium tienes 3 análisis nuevos al día. Volver a ver una partida que ya analizaste no gasta análisis. Con Premium analizas todas las partidas que quieras. De momento el análisis está disponible para partidas de dos jugadores.",
        ],
      },
      {
        h: "Cómo sacarle partido",
        list: [
          "Busca primero los errores graves: casi siempre hay uno o dos que deciden la partida.",
          "En cada error, mira la flecha verde y pregúntate por qué esa jugada era mejor.",
          "Fíjate en si tus errores se repiten: meter el especial pronto, descuidar un escalón…",
        ],
      },
    ],
    faqs: [
      ["¿El análisis es gratis?", "Sí, 3 análisis nuevos al día. Con Premium no hay límite."],
      ["¿Qué es la flecha verde?", "La jugada que el bot habría hecho en tu lugar."],
      ["¿Puedo analizar partidas de cuatro jugadores?", "Todavía no. El análisis funciona en partidas de dos jugadores."],
    ],
    related: ["replay/controles", "premium", "bots", "estrategia"],
    cta: { label: "Ver Premium", slug: "premium" },
    legacy: [
      "replay/estudiar-errores",
      "replay/compartir-aprendizaje",
      "articulos/analizar-partida-paso-a-paso",
    ],
  },
  {
    slug: "descargar-video",
    theme: "historial",
    nav: "Descargar el video de una partida",
    title: "Descargar el video de una partida de XIMA",
    description:
      "Convierte cualquier partida de XIMA en un video MP4 horizontal o vertical para YouTube, TikTok o WhatsApp. Cómo hacerlo y qué necesitas.",
    h1: "Descargar el video de una partida",
    intro:
      "Con Descargar partido conviertes una partida en un video MP4 para guardarla o compartirla en tus redes.",
    sections: [
      {
        h: "Cómo se hace",
        p: [
          "Abre la repetición de la partida y pulsa Descargar partido. El video se prepara en tu propio ordenador, sin que tengas que esperar a nadie, y al terminar se descarga solo.",
        ],
      },
      {
        h: "Cómo es el video",
        list: [
          "Formato horizontal (1920 × 1080) para YouTube o vertical (1080 × 1920) para TikTok, Reels o Estados de WhatsApp.",
          "Una breve introducción, cada jugada a buen ritmo (un poco más lenta si hubo dados) y unos segundos finales con el resultado.",
        ],
      },
      {
        h: "Quién puede descargarlo",
        p: [
          "La descarga de videos es una función Premium. Si te gusta compartir tus partidas, Premium te permite hacer todos los videos que quieras.",
        ],
      },
    ],
    faqs: [
      ["¿Qué formato tiene el video?", "MP4, en horizontal (1920 × 1080) o en vertical (1080 × 1920)."],
      ["¿Necesito Premium para descargar videos?", "Sí, la descarga de videos es para cuentas Premium."],
    ],
    related: ["premium", "replay/controles", "historial-y-replay"],
    cta: { label: "Ver Premium", slug: "premium" },
  },
];
